module.exports = __webpack_public_path__ + "static/media/b-sci-major-2_LR.f645833f.jpg";